import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ThumbsUp, ThumbsDown } from '@phosphor-icons/react';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

const RatingView = ({
    artist,
    song,
    metaType,
    isLive,
    currentMetaId,
    settingRating,
    rating,
    getLocalStoreRating,
    onLiked,
    onDisliked,
}) => {
    useEffect(() => {
        getLocalStoreRating();
    }, [getLocalStoreRating]);

    const [activeLikeBtn, setActiveLikeBtn] = useState(null);
    const [activeUnlikeBtn, setActiveUnlikeBtn] = useState(null);

    useEffect(() => {
        if (settingRating === false) {
            setActiveLikeBtn(null);

            setActiveUnlikeBtn(null);
        }
    }, [settingRating, rating])

    const handleActiveEffect = (likeType) => {
        if (likeType === 'like') {
            setActiveLikeBtn(true);

            onLiked();
        } else {
            setActiveUnlikeBtn(true);

            onDisliked();
        }
    }

    // disable the voting if:
    //  - there is no artist or song information
    //  - it is not the live stream that is playing
    //  - the default meta data is being used
    //  - it is NOT the principal stream that is playing
    const voteDisabled = !artist || !song || !isLive || metaType !== 'music' || currentMetaId !== 'antena_1';
    const buttonsDisabled = rating !== null || settingRating || voteDisabled;

    //    if (settingRating) {
    //        return (
    //            <div className="tw-flex tw-items-center tw-justify-center tw-h-12">
    //                <Spinner size={28} className="tw-animate-spin tw-text-gray-600" />
    //            </div>
    //        );
    //    }


    return (
        <div className="tw-flex tw-items-center tw-space-x-4">

            <Button
                onClick={() => handleActiveEffect('like')}
                title={buttonsDisabled ? 'Você já votou' : 'Gostei'}
                disabled={buttonsDisabled}
                className={`tw-flex tw-mr-[50px] tw-items-center
                    ${activeLikeBtn === true ? 'pulseBtnForBar tw-rounded-lg' : ''}
                    ${buttonsDisabled ? 'tw-opacity-70 tw-cursor-default' : 'tw-cursor-pointer'}
`}
            >
                <ThumbsUp
                    size={20}
                    className={`tw-mr-[5px] ${settingRating === false && rating === 10 ? 'tw-text-green-500' : 'tw-text-black lg:tw-text-white'} `}
                    weight={settingRating === false && rating === 10 ? 'fill' : 'regular'}
                />
                <span className={`tw-text-sm ${settingRating === false && rating === 10 ? 'tw-text-green-500' : 'tw-text-black lg:tw-text-white'}`}>Gostei</span>
            </Button>


            <Button
                onClick={() => handleActiveEffect('dislike')}
                title={buttonsDisabled ? 'Você já votou' : 'Não gostei'}
                disabled={buttonsDisabled}
                className={`disableSpace tw-flex tw-items-center
                    ${activeUnlikeBtn === true ? 'pulseBtnForBar tw-rounded-lg' : ''}
                    ${buttonsDisabled ? 'tw-opacity-70 tw-cursor-default' : 'tw-cursor-pointer'}
                    `}
            >
                <ThumbsDown
                    size={20}
                    className={`tw-mr-[5px] ${settingRating === false && rating === 1 ? 'tw-text-red-500' : 'tw-text-black lg:tw-text-white'}`}
                    weight={settingRating === false && rating === 1 ? 'fill' : 'regular'}
                />
                <span className={`tw-text-sm ${settingRating === false && rating === 1 ? 'tw-text-red-500' : 'tw-text-black lg:tw-text-white'}`}>Não Gostei</span>
            </Button>
        </div>
    );
};

RatingView.propTypes = exact({
    artist: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    song: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    metaType: PropTypes.string,
    isLive: PropTypes.bool.isRequired,
    currentMetaId: PropTypes.string.isRequired,
    settingRating: PropTypes.bool.isRequired,
    rating: PropTypes.number,
    getLocalStoreRating: PropTypes.func.isRequired,
    onLiked: PropTypes.func.isRequired,
    onDisliked: PropTypes.func.isRequired,
});

export default RatingView;
